import { UserRole } from '../models/user';

export const isUserAdmin = (role: UserRole): boolean => {
  return role === 'ADMIN' || role === 'SUPER_ADMIN';
};

export const isUserSuperAdmin = (role: UserRole): boolean => {
  return role === 'SUPER_ADMIN';
};

export const getRoleLabel = (role: UserRole): string => {
  return (
    {
      ADMIN: 'Admin',
      SUPER_ADMIN: 'Super Admin',
      USER: 'User',
    }[role] || ''
  );
};
